import { styled } from "@mui/material";
import Grid from "../../../../node_modules/@mui/material/Grid/Grid.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
const DialogGridContainer = styled(Grid)({
  gap: Spacing["1500"],
  textAlign: Alignment.center
});
const DialogIconContainer = styled("div")({
  textAlign: Alignment.center
});
export {
  DialogGridContainer,
  DialogIconContainer
};
//# sourceMappingURL=container.es.js.map
